export const DAILY_CONTAINER_BOOKING_JD_TEAM = [
  {
    id: "expander",
    Header: ({ getToggleAllRowsExpandedProps, isAllRowsExpanded }) => (
      <span {...getToggleAllRowsExpandedProps()}>
        <i
          className={
            isAllRowsExpanded ? "fi fi-rr-minus-small" : "fi fi-rr-plus-small"
          }
        ></i>
      </span>
    ),
    Cell: ({ row }) =>
      row.canExpand ? (
        <span {...row.getToggleRowExpandedProps()}>
          <i
            className={
              row.isExpanded ? "fi fi-rr-minus-small" : "fi fi-rr-plus-small"
            }
          ></i>
        </span>
      ) : null,
  },
  {
    Header: "UPLOAD DATE",
    accessor: "Date",
    width : 1
  },
  {
    Header: "MARKET",
    accessor: "Market",
    width : 1
  },
  {
    Header: "VARIANT",
    accessor: "Varient_PartNumber",
    width : 1
  },
  {
    Header: "QUANTITY",
    accessor: "Quantity",
    width : 1
  },
  {
    Header: "CONTAINER COUNT",
    accessor: "Container_Count",
    width : 1
  },
  {
    Header: "COUNTRY",
    accessor: "Country",
    width : 1
  },
  {
    Header: "SI",
    accessor: "SI",
    width : 1
  },
  {
    Header: "REMARK",
    accessor: "Remark",
    width : 1
  },
  {
    Header: "CARRIER",
    accessor: "Carrier",
  },
  {
    Header: "BOOKING NO",
    accessor: "Booking_Number",
    width : 1
  },
  {
    Header: "BOOKING DOC",
    accessor: "Booking_Doc",
    width : 1
  },
  {
    Header: "REASON",
    accessor: "Reason",
    width : 1
  },
  {
    Header: "HOLD REASON",
    accessor: "HoldReason",
    width : 1
  },
  {
    Header: "STATUS",
    accessor: "STATUS",
    width : 1
  },
  {
    Header: "VSL/VOY",
    accessor: "VSL_VOY",
    width : 900
  },
  {
    Header: "CONTAINER TYPE",
    accessor: "Container_Type",
    width : 1
  },
  {
    Header: "ETD",
    accessor: "ETD",
  },
  {
    Header: "ETA",
    accessor: "ETA",
  },
  {
    Header: "PORT OF DESTINATION",
    accessor: "Port_Of_Destination",
    width : 1
  },
  {
    Header: "FINAL DESTINATION",
    accessor: "final_destination",
    width : 900
  },
  {
    Header: "JD STUFFING DATE",
    accessor: "JD_Stuffing_Date",
  },
  {
    Header: "TRANSPORTER",
    accessor: "Transporter",
  },
  {
    Header: "PICK UP LOACTION",
    accessor: "PickUpLocation",
    width : 1
  },
  {
    Header: "INSPECTION",
    accessor: "Inspection",
    width : 1
  },
  {
    Header: "GROUND RENT DAYS",
    accessor: "Ground_Rent_Days",
  },
  {
    Header: "ORIGIN TRANSIT TIME",
    accessor: "Origin_Transit_Time",
  },
  {
    Header: "APPROX CONTAINER DETENTION",
    accessor: "Approx_container_detention",
  },
  {
    Header: "HOLD",
    accessor: "Holdtoggle",
    width : 1
  },
  {
    Header: "ACTION",
    accessor: "action",
    width : 1
  },
];

export const DAILY_CONTAINER_BOOKING_PUNE_TEAM = [
  {
    id: "expander",
    Header: ({ getToggleAllRowsExpandedProps, isAllRowsExpanded }) => (
      <span {...getToggleAllRowsExpandedProps()}>
        <i
          className={
            isAllRowsExpanded ? "fi fi-rr-minus-small" : "fi fi-rr-plus-small"
          }
        ></i>
      </span>
    ),
    Cell: ({ row }) =>
      row.canExpand ? (
        <span {...row.getToggleRowExpandedProps()}>
          <i
            className={
              row.isExpanded ? "fi fi-rr-minus-small" : "fi fi-rr-plus-small"
            }
          ></i>
        </span>
      ) : null,
  },
  {
    Header: "UPLOAD DATE",
    accessor: "Date",
    width : 1
  },
  {
    Header: "MARKET",
    accessor: "Market",
    width : 1
  },
  {
    Header: "VARIANT",
    accessor: "Varient_PartNumber",
    width : 1
  },
  {
    Header: "QUANTITY",
    accessor: "Quantity",
    width : 1
  },
  {
    Header: "CONTAINER COUNT",
    accessor: "Container_Count",
    width : 1
  },
  {
    Header: "COUNTRY",
    accessor: "Country",
    width : 1
  },
  {
    Header: "SI",
    accessor: "SI",
    width : 1
  },
  {
    Header: "REMARK",
    accessor: "Remark",
    width : 1
  },
  {
    Header: "CARRIER",
    accessor: "Carrier",
  },
  {
    Header: "BOOKING NO",
    accessor: "Booking_Number",
    width : 1
  },
  {
    Header: "BOOKING DOC",
    accessor: "Booking_Doc",
    width : 1
  },
  {
    Header: "REASON",
    accessor: "Reason",
    width : 1
  },

  {
    Header: "HOLD",
    accessor: "Holdtoggle",
    width : 1
  },
  {
    Header: "HOLD REASON",
    accessor: "HoldReason",
    width : 1
  },
  {
    Header: "STATUS",
    accessor: "STATUS",
    width : 1
  },
  {
    Header: "VSL/VOY",
    accessor: "VSL_VOY",
    width : 900
  },
  {
    Header: "CONTAINER TYPE",
    accessor: "Container_Type",
    width : 1
  },
  {
    Header: "ETD",
    accessor: "ETD",
  },
  {
    Header: "ETA",
    accessor: "ETA",
  },
  {
    Header: "PORT OF DESTINATION",
    accessor: "Port_Of_Destination",
    width : 1
  },
  {
    Header: "FINAL DESTINATION",
    accessor: "final_destination",
    width : 900
  },
  {
    Header: "JD STUFFING DATE",
    accessor: "JD_Stuffing_Date",
  },
  {
    Header: "TRANSPORTER",
    accessor: "Transporter",
  },
  {
    Header: "INSPECTION",
    accessor: "Inspection",
    width : 1
  },
  {
    Header: "PICK UP LOACTION",
    accessor: "PickUpLocation",
    width : 1
  },
  {
    Header: "GROUND RENT DAYS",
    accessor: "Ground_Rent_Days",
  },
  {
    Header: "ORIGIN TRANSIT TIME",
    accessor: "Origin_Transit_Time",
  },
  {
    Header: "APPROX CONTAINER DETENTION",
    accessor: "Approx_container_detention",
  },
  {
    Header: "HOLD",
    accessor: "Holdtoggle",
    width : 1
  },
];

export const DAILY_CONTAINER_BOOKING_PUNE_TEAM_WITH_DELETE = [
  {
    id: "expander",
    Header: ({ getToggleAllRowsExpandedProps, isAllRowsExpanded }) => (
      <span {...getToggleAllRowsExpandedProps()}>
        <i
          className={
            isAllRowsExpanded ? "fi fi-rr-minus-small" : "fi fi-rr-plus-small"
          }
        ></i>
      </span>
    ),
    Cell: ({ row }) =>
      row.canExpand ? (
        <span {...row.getToggleRowExpandedProps()}>
          <i
            className={
              row.isExpanded ? "fi fi-rr-minus-small" : "fi fi-rr-plus-small"
            }
          ></i>
        </span>
      ) : null,
  },
  {
    Header: "ADD",
    accessor: "Add",
    width : 60
  },
  {
    Header: "OFP PLAN DATE",
    accessor: "Date",
    width : 150
  },
  {
    Header: "MARKET",
    accessor: "Market",
    width : 140
  },
  {
    Header: "VARIANT",
    accessor: "Varient_PartNumber",
    width : 120
  },
  {
    Header: "QUANTITY",
    accessor: "Quantity",
    width : 125
  },
  {
    Header: "CONTAINER COUNT",
    accessor: "Container_Count",
    width : 190
  },
  {
    Header: "COUNTRY",
    accessor: "Country",
    width : 120
  },
  {
    Header: "SI",
    accessor: "SI",
    width : 180
  },
  {
    Header: "REMARK",
    accessor: "Remark",
    width : 180
  },
  {
    Header: "CARRIER",
    accessor: "Carrier",
    width : 225
  },
  {
    Header: "BOOKING NO",
    accessor: "Booking_Number",
    width : 260
  },
  {
    Header: "BOOKING DOC",
    accessor: "Booking_Doc",
    width : 300
  },
  {
    Header: "REASON",
    accessor: "Reason",
    width : 110
  },
  {
    Header: "HOLD REASON",
    accessor: "HoldReason",
    width : 1
  },
  {
    Header: "STATUS",
    accessor: "STATUS",
    width : 110
  },
  {
    Header: "VSL/VOY",
    accessor: "VSL_VOY",
    width : 180
  },
  {
    Header: "CONTAINER TYPE",
    accessor: "Container_Type",
    width : 170
  },
  {
    Header: "FACTORY STATUS",
    accessor: "Factory_Status",
    width : 110
  },
  {
    Header: "ETD",
    accessor: "ETD",
    width : 160
  },
  {
    Header: "ETA",
    accessor: "ETA",
    width : 160
  },
  {
    Header: "PORT OF DESTINATION",
    accessor: "Port_Of_Destination",
    width : 260
  },
  {
    Header: "FINAL DESTINATION",
    accessor: "final_destination",
    width : 260
  },
  {
    Header: "JD STUFFING DATE",
    accessor: "JD_Stuffing_Date",
    width : 180
  },
  {
    Header: "TRANSPORTER",
    accessor: "Transporter",
    width : 225
  },
  {
    Header: "INSPECTION",
    accessor: "Inspection",
    width : 140
  },
  {
    Header: "PICK UP LOACTION",
    accessor: "PickUpLocation",
    width : 1
  },
  {
    Header: "GROUND RENT DAYS",
    accessor: "Ground_Rent_Days",
    width : 195
  },
  {
    Header: "ORIGIN TRANSIT TIME",
    accessor: "Origin_Transit_Time",
    width : 200
  },
  {
    Header: "APPROX CONTAINER DETENTION",
    accessor: "Approx_container_detention",
    width : 275
  },
  {
    Header: "HOLD",
    accessor: "Holdtoggle",
    width : 1
  },
  // {
  //   Header: "DELETE",
  //   accessor: "Delete",
  //   width : 100
  // },

   
];

export const COUNTRY_WISE_WEEKLY_PLAN = [
  {
    Header: "COUNTRY",
    accessor: "Country",
  },
  {
    Header: "PLANNING MONTH",
    accessor: "PlanningMonth",
  },
  {
    Header: "WEEK 1",
    accessor: "W1",
  },
  {
    Header: "WEEK 2",
    accessor: "W2",
  },
  {
    Header: "WEEK 3",
    accessor: "W3",
  },
  {
    Header: "WEEK 4",
    accessor: "W4",
  },
  {
    Header: "WEEK 5",
    accessor: "W5",
  },
  {
    Header: "TOTAL",
    accessor: "TotalMonth",
  },
];

export const MARKET_WISE_WEEKLY_PLAN = [
  {
    Header: "MARKET",
    accessor: "Market",
  },
  {
    Header: "PLANNING MONTH",
    accessor: "PlanningMonth",
  },
  {
    Header: "WEEK 1",
    accessor: "W1",
  },
  {
    Header: "WEEK 2",
    accessor: "W2",
  },
  {
    Header: "WEEK 3",
    accessor: "W3",
  },
  {
    Header: "WEEK 4",
    accessor: "W4",
  },
  {
    Header: "WEEK 5",
    accessor: "W5",
  },
  {
    Header: "TOTAL",
    accessor: "TotalMonth",
  },
];

export const NEW_COLUMN_TRACTOR_DATA = [
  {
    Header: "FINAL DESTINATION",
    accessor: "Final_Destination",
  },
  {
    Header: "VSL/VOY",
    accessor: "VSL_VOY",
    width : 900
  },
  {
    Header: "ETD",
    accessor: "ETD",
  },
  {
    Header: "ETA",
    accessor: "ETA",
  },
  {
    Header: "BKG NO",
    accessor: "BookingNo",
  },
  {
    Header: "CARRIER",
    accessor: "Carrier",
  },
  {
    Header: "FACTORY IN DATE",
    accessor: "Factory_In_Date",
  },
  {
    Header: "FACTORY OUT DATE",
    accessor: "Factory_Out_Date",
  },
  {
    Header: "JD STUFFING DATE",
    accessor: "JD_Stuffing_Date",
  },
  {
    Header: "TRANSPORTER",
    accessor: "Transporter",
  },
  {
    Header: "OTHER TRANSPORTER",
    accessor: "Other_Transporter",
  },
  {
    Header: "GROUND RENT DAYS",
    accessor: "Ground_Rent_Days",
  },
  {
    Header: "ORIGIN TRANSIT TIME",
    accessor: "Origin_Transit_Time",
  },
  {
    Header: "APPROX CONTAINER DETENTION",
    accessor: "Approx_container_detention",
  },
  {
    Header: "REMARK",
    accessor: "Remark",
  },
];

export const EMAIL_WINDOW_COLUMN=[
  {
    id: "expander",
    Header: ({ getToggleAllRowsExpandedProps, isAllRowsExpanded }) => (
      <span {...getToggleAllRowsExpandedProps()}>
        <i
          className={
            isAllRowsExpanded ? "fi fi-rr-minus-small" : "fi fi-rr-plus-small"
          }
        ></i>
      </span>
    ),
    Cell: ({ row }) =>
      row.canExpand ? (
        <span {...row.getToggleRowExpandedProps()}>
          <i
            className={
              row.isExpanded ? "fi fi-rr-minus-small" : "fi fi-rr-plus-small"
            }
          ></i>
        </span>
      ) : null,
  },
  {
    Header: "EMAIL STATUS",
    accessor: "email_status",
    width : 1
  },
  {
    Header: "MODULE NAME",
    accessor: "DataOf",
    width : 1
  },
  {
    Header: "OFP PLAN DATE",
    accessor: "Date",
    width : 1
  },
  {
    Header: "Reason",
    accessor: "Reason",
    width : 1
  },
  {
    Header: "JD STUFFING DATE",
    accessor: "JD_Stuffing_Date",
    width : 1
  },
  {
    Header: "TRANSPORTER",
    accessor: "Transporter",
  },
  {
    Header: "COUNTRY",
    accessor: "Country",
    width : 1
  },
  {
    Header: "PORT OF DESTINATION",
    accessor: "Port_Of_Destination",
    width : 1
  },
  {
    Header: "CONTAINER COUNT",
    accessor: "Container_Count",
    width : 1
  },
  {
    Header: "CONTAINER TYPE",
    accessor: "Container_Type",
    width : 1
  },
  {
    Header: "BOOKING NO.",
    accessor: "Booking_Number",
    width : 1
  },
  {
    Header: "CARRIER",
    accessor: "Carrier",
  },
]
export const CONTAINER_WISE_COLUMN=[
  {
    Header: "CONTAINER NUMBER",
    accessor: "Container_Number",
    width : 1
  },
  {
    Header: "BOOKING NUMBER",
    accessor: "Booking_Number",
    width : 1
   },
  {
    Header: "DATE",
    accessor: "Date",
    width : 1
  },
 /*  {
    Header: "MARKET",
    accessor: "Market",
    width : 1
   },
   {
    Header: "COUNTRY",
    accessor: "Country",
    width : 1
    }, */
  {
    Header: "TYPE",
    accessor: "Module_Type",
    width : 1
  },
  
  
  // {
  //   Header: "TRANSPORTER DATA ID",
  //   accessor: "TransporterDataId",
  //   show :true
   
  // },
  

  // {
  //   Header: "ASSIGN CONTAINER ID",
  //   accessor: "AssignContainerId",
  //   show :true
  
  // },
 
]

export const CONTAINER_WISE_SWAP_COLUMN=[
  {
    Header: "CONTAINER NUMBER",
    accessor: "Container_Number",
    width : 1
  },
  {
    Header: "BOOKING NUMBER",
    accessor: "Booking_Number",
    width : 1
   },
/*   {
    Header: "DATE",
    accessor: "Date",
    width : 1
  }, */
   {
    Header: "MARKET",
    accessor: "Market",
    width : 1
   },
   {
    Header: "COUNTRY",
    accessor: "Country",
    width : 1
    },
 /*  {
    Header: "TYPE",
    accessor: "Module_Type",
    width : 1
  }, */
  
  
  // {
  //   Header: "TRANSPORTER DATA ID",
  //   accessor: "TransporterDataId",
  //   show :true
   
  // },
  

  // {
  //   Header: "ASSIGN CONTAINER ID",
  //   accessor: "AssignContainerId",
  //   show :true
  
  // },
 
]
